// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { LibrarySubsessionInfo, LibrarySymbolInfo, ResolutionString, Timezone, VisiblePlotsSet } from "../../../Libs/TradingViewChart/charting_library_cloned_data/charting_library/charting_library";
import { TvUtcTimeZone } from "./TvConstants";
import { DataStatusEnum, SeriesFormatEnum, TvChartSupportedResolutionArray, VisiblePlotsSetEnum } from "./TvEnums";
import { TvSymbolInfoPriceSource } from "./TvSymbolInfoPriceSource";

export class TvSymbol implements LibrarySymbolInfo
{
    ticker = "symbol name";
    name = "name";
    full_name = "full name";
    description = "description";
    type = "type string";
    pricescale = 10; //Math.pow(10, presicion);
    volume_precision = 1;
    exchange = "trading exchange name";
    listed_exchange = "market exchange name";
    sector = "sector";
    industry = "industry";

    session = "session string"; //'24x7'
    session_holidays = "";
    corrections = "";
    subsession_id = "";
    subsessions: LibrarySubsessionInfo[];

    minmov = 1;

    supported_resolutions = <ResolutionString[]>[...TvChartSupportedResolutionArray];

    intraday_multipliers = ['1', '5', '15', '30', '60', '240'];
    daily_multipliers = ['1']; //TvChartSupportedResolutionArray
    monthly_multipliers = ['1', '12'];

    has_weekly_and_monthly = true;
    has_daily = true;
    has_intraday = true;
    has_seconds = false;
    has_ticks = false;

    has_empty_bars = false;


    logo_urls;

    timezone = <Timezone>TvUtcTimeZone;
    visible_plots_set = VisiblePlotsSetEnum.ohlcv;
    data_status = DataStatusEnum.streaming;
    delay: number = 0;

    expired;
    expiration_date;

    public variable_tick_size: string;

    public price_source_id?: string;
    public price_sources?: TvSymbolInfoPriceSource[];

    public format: SeriesFormatEnum;
}